import React from "react";
import classnames from "classnames";
import "./TradeDirectionArrows.sass";

const CHEVRON_PATH =
  "M16.2751 9.55829C16.5193 9.80245 16.5193 10.1983 16.2751 10.4425L10.4418 16.2758C10.3201 16.3975 10.1601 16.4591 10.0001 16.4591C9.84006 16.4591 9.68004 16.3983 9.55837 16.2758L3.72504 10.4425C3.48087 10.1983 3.48087 9.80245 3.72504 9.55829C3.9692 9.31412 4.36507 9.31412 4.60923 9.55829L10.0009 14.9499L15.3925 9.55829C15.6359 9.31412 16.0309 9.31412 16.2751 9.55829Z";

const Chevron = ({ modifier }) => (
  <svg
    className={`trade-direction-arrows__chevron trade-direction-arrows__chevron--${modifier}`}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={CHEVRON_PATH} fill="currentColor" />
  </svg>
);

/**
 * Animated double chevron (Long ⌃⌃ / Short ⌄⌄).
 * @param {object} props
 * @param {'long' | 'short'} props.direction
 * @param {boolean} [props.isAnimating]
 * @param {number} [props.size]
 * @param {string} [props.color] Without it the icon takes color from CSS / parent.
 * @param {string} [props.className]
 */
export const TradeDirectionArrows = ({
  direction,
  isAnimating = false,
  size = 20,
  color,
  className,
}) => (
  <span
    className={classnames(
      "trade-direction-arrows",
      `trade-direction-arrows--${direction}`,
      { "trade-direction-arrows--animating": isAnimating },
      className
    )}
    style={{ width: size, height: size, ...(color ? { color } : {}) }}
    aria-hidden="true"
  >
    <Chevron modifier="first" />
    <Chevron modifier="second" />
  </span>
);

export default TradeDirectionArrows;
